import React, { useEffect, useState } from "react";
import { useCreateReworkPackingDataMutation } from "../rework/reworkApi";
import { Col, Row } from "react-bootstrap";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import SelectBox from "../../../components/shared/fields/SelectBox ";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import Button from "../../../components/shared/buttons/button";
import useTranslator from "../../../hooks/useTranslator";

const RewarkPackedDataModal = ({ show, setShow, record, mode, lot_number_id, data_source="rework",data_type=null }) => {

  const { _t } = useTranslator();  

  const [createReworkPackingData, { isLoading: isCreating }] =
    useCreateReworkPackingDataMutation();

  const initialFormData = {
    lot_number_id: lot_number_id,
    pallets: "",
    boxes_packed: "",
    packed_before_lunch_type_one: "",
    packed_before_lunch_type_two: "",
    packed_after_lunch_type_one: "",
    packed_after_lunch_type_two: "",
    second_before_lunch_type_two: "",
    second_after_lunch_type_two: "",
    tapita_before_lunch_type_two: "",
    tapita_after_lunch_type_two: "",
    pieces_before_lunch_type_two: "",
    pieces_after_lunch_type_two: "",
    type: mode === "cheeks" ? "cheeks" : "strips",
  };

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if ((mode === "editCheeks" || mode === "editStrips") && record !== null) {
      setFormData(record);
    } else {
      setFormData(initialFormData);
    }
  }, [mode, record, show]);

  const handleClose = () => {
    setShow(false);
  };

  const isStrips = mode === "strips" || mode === "editStrips";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isCreating) return;

    try {
      const payload = { data_source,data_type, ...formData };
      if (isStrips) {
        delete payload.packed_before_lunch_type_one;
        delete payload.packed_after_lunch_type_one;
      }
      await createReworkPackingData(payload).unwrap();
      handleClose();
    } catch (error) {
      console.error("Error creating/updating manager:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedFormData = {
      ...formData,
      [name]: value,
    };

    // Automatically update boxes_packed as the sum of all packed boxes
    if (
      name === "packed_before_lunch_type_one" ||
      name === "packed_before_lunch_type_two" ||
      name === "packed_after_lunch_type_one" ||
      name === "packed_after_lunch_type_two" ||
      name === "second_before_lunch_type_two" ||
      name === "second_after_lunch_type_two" ||
      name === "tapita_before_lunch_type_two" ||
      name === "tapita_after_lunch_type_two" ||
      name === "pieces_before_lunch_type_two" ||
      name === "pieces_after_lunch_type_two"
    ) {
      const packedBeforeLunchTypeOne = isStrips ? 0 : parseInt(
        updatedFormData.packed_before_lunch_type_one || 0,
        10
      );

      const packedBeforeLunchTypeTwo = parseInt(
        updatedFormData.packed_before_lunch_type_two || 0,
        10
      );

      const packedAfterLunchTypeOne = isStrips ? 0 : parseInt(
        updatedFormData.packed_after_lunch_type_one || 0,
        10
      );

      const packedAfterLunchTypeTwo = parseInt(
        updatedFormData.packed_after_lunch_type_two || 0,
        10
      );

      const secondBeforeLunchTypeTwo = parseInt(
        updatedFormData.second_before_lunch_type_two || 0,
        10
      );

      const secondAfterLunchTypeTwo = parseInt(
        updatedFormData.second_after_lunch_type_two || 0,
        10
      );

      const tapitatBeforeLunchTypeTwo = parseInt(
        updatedFormData.tapita_before_lunch_type_two || 0,
        10
      );

      const tapitatAfterLunchTypeTwo = parseInt(
        updatedFormData.tapita_after_lunch_type_two || 0,
        10
      );

      const piecesBeforeLunchTypeTwo = parseInt(
        updatedFormData.pieces_before_lunch_type_two || 0,
        10
      );

      const piecesAfterLunchTypeTwo = parseInt(
        updatedFormData.pieces_after_lunch_type_two || 0,
        10
      );

      const totalBoxesPacked =
        packedBeforeLunchTypeOne +
        packedBeforeLunchTypeTwo +
        packedAfterLunchTypeOne +
        packedAfterLunchTypeTwo +
        secondBeforeLunchTypeTwo +
        secondAfterLunchTypeTwo +
        tapitatBeforeLunchTypeTwo +
        tapitatAfterLunchTypeTwo +
        piecesBeforeLunchTypeTwo +
        piecesAfterLunchTypeTwo;

      updatedFormData.boxes_packed = totalBoxesPacked.toString();

      // Calculate pallets based on boxes_packed / 80
      updatedFormData.pallets = Math.floor(totalBoxesPacked / 80);
    }

    setFormData(updatedFormData);
  };

  const renderFormFields = () => (
    <>
      <Col lg={6}>
        <SelectBox
          label={_t("packeddata_modal_type", "Type")}
          type="text"
          name="type"
          value={formData.type}
          options={[
            { value: "cheeks", label: _t("packeddata_modal_cheeks", "Cheeks") },
            { value: "strips", label: _t("packeddata_modal_strips", "Strips") },
          ]}
          onChange={handleChange}
          disabled={true}
        />
      </Col>
      <Col lg={6}></Col>
      {!isStrips && (
        <>
        <Col lg={6}>
          <InputWithLabel
            label={
              _t("packeddata_modal_packed_before_lunch", "Prime Packed Before Lunch") +
              " " + _t("ten_pounds", "(10 pounds)")
            }
            type="number"
            name="packed_before_lunch_type_one"
            value={formData.packed_before_lunch_type_one}
            onChange={handleChange}
            placeholder={"0"}
          />
        </Col>

        <Col lg={6}>
          <InputWithLabel
            label={
              _t("packeddata_modal_packed_after_lunch", "Prime Packed After Lunch") +
              " " + _t("ten_pounds", "(10 pounds)")
            }
            type="number"
            name="packed_after_lunch_type_one"
            value={formData.packed_after_lunch_type_one}
            onChange={handleChange}
            placeholder={"0"}
          />
        </Col>
        </>
      )}
      <Col lg={6}>
        <InputWithLabel
          label={
            _t(
              "packeddata_modal_packed_before_lunch",
              "Prime Packed Before Lunch"
            ) + " " + _t("twenty_pounds", "(20 pounds)")
          }
          type="number"
          name="packed_before_lunch_type_two"
          value={formData.packed_before_lunch_type_two}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>
    
      <Col lg={6}>
        <InputWithLabel
          label={
            _t(
              "packeddata_modal_packed_after_lunch",
              "Prime Packed After Lunch"
            ) + " " + _t("twenty_pounds", "(20 pounds)")
          }
          type="number"
          name="packed_after_lunch_type_two"
          value={formData.packed_after_lunch_type_two}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t(
            "seconds_packed_before_lunch_20_pound_label",
            "Seconds Packed Before Lunch (20 pounds)"
          )}
          type="number"
          name="second_before_lunch_type_two"
          value={formData.second_before_lunch_type_two}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t(
            "seconds_packed_after_lunch_20_pound_label",
            "Seconds Packed After Lunch (20 pounds)"
          )}
          type="number"
          name="second_after_lunch_type_two"
          value={formData.second_after_lunch_type_two}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>

      {/* Cheeks specific fields */}
      {formData.type === "cheeks" && (
        <>
          <Col lg={6}>
            <InputWithLabel
              label={_t(
                "tapita_packed_before_lunch_20_pound_label",
                "Tapita Packed Before Lunch (20 pounds)"
              )}
              type="number"
              name="tapita_before_lunch_type_two"
              value={formData.tapita_before_lunch_type_two}
              onChange={handleChange}
              placeholder={"0"}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t(
                "tapita_packed_after_lunch_20_pound_label",
                "Tapita Packed After Lunch (20 pounds)"
              )}
              type="number"
              name="tapita_after_lunch_type_two"
              value={formData.tapita_after_lunch_type_two}
              onChange={handleChange}
              placeholder={"0"}
            />
          </Col>
        </>
      )}

      {/* Pieces 20 Pound fields for both Cheeks and Strips */}
      <Col lg={6}>
        <InputWithLabel
          label={_t(
            "pieces_packed_before_lunch_20_pound_label",
            "Pieces Packed Before Lunch (20 pounds)"
          )}
          type="number"
          name="pieces_before_lunch_type_two"
          value={formData.pieces_before_lunch_type_two}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t(
            "pieces_packed_after_lunch_20_pound_label",
            "Pieces Packed After Lunch (20 pounds)"
          )}
          type="number"
          name="pieces_after_lunch_type_two"
          value={formData.pieces_after_lunch_type_two}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>

      <Col lg={6}>
        <InputWithLabel
          label={`${_t("pallets_label", "Pallets")} ${
            formData.type === "cheeks"
              ? _t("packeddata_modal_cheeks", "Cheeks")
              : _t("packeddata_modal_strips", "Strips")
          }`}
          type="number"
          name="pallets"
          value={formData.pallets}
          disabled={true}
          placeholder={"0"}
        />
      </Col>
    </>
  );

  const modeLabels = {
    cheeks: _t("add_cheeks_packing", "Add Cheeks Packing"),
    strips: _t("add_strips_packing", "Add Strips Packing"),
    editCheeks: _t("edit_cheeks_packing", "Edit Cheeks Packing"),
    editStrips: _t("edit_strips_packing", "Edit Strips Packing"),
  };

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={modeLabels[mode]}
      children={formData}
    >
      <Row>{renderFormFields()}</Row>

      <Row>
        <Col className="text-end">
          <Button
            label={_t("packeddata_modal_save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
            disabled={isCreating}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default RewarkPackedDataModal;
